import Vue from "vue";
import VueRouter from "vue-router";
import beforeEach from "./beforeEach";
import index from "../page/index";
import schoolCommon from "../page/schoolCommon";
import demo111111 from "../page/demo111111";
import study from "../page/study";
import answers from "../page/answers";
import consult from "../page/consult";
import regard from "../page/regard";
import schoolnew from "../page/schoolnew/schoolnew";
import introduce from "../page/introduce";
import collegenotice from "../page/collegenotice";
import collegetwo from "../page/collegenoticetwo/collegetwo";
import content from "../page/views/content";
import zyjs from "../page/zyjs";
Vue.use(VueRouter);

//防止报错:Error: Avoided redundant navigation to current location:路由
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

const routes = [
  //测试页面
  {
    path: "/demo111111",
    name: "demo111111",
    // redirect:'/demo',
    component: () => import("@/page/demo111111.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  //首页
  {
    path: "/",
    name: "index",
    // redirect:'/index',
    component: () => import("@/page/index.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  //学校信息库
  {
    path: "/schoolCommon",
    name: "schoolCommon",
    // redirect:'/demo',
    component: () => import("@/page/schoolCommon.vue"), 
    meta:{
      keepAlive: false,//此组件需要被缓存
      isBack: false,
  }

  },
  //留学攻略
  {
    path: "/study",
    name: "study",
    // redirect:'/demo',
    component: () => import("@/page/study.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  //留学问答
  {
    path: "/answers",
    name: "answers",
    // redirect:'/demo',
    component: () => import("@/page/answers.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  //留学生活
  {
    path: "/life",
    name: "life",
    // redirect:'/demo',
    component: () => import("@/page/life.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  //留学咨询
  {
    path: "/consult",
    name: "consult",
    // redirect:'/demo',
    component: () => import("@/page/consult.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  //关于我们
  {
    path: "/regard",
    name: "regard",
    // redirect:'/demo',
    component: () => import("@/page/regard.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  // 学校详情
  {
    path: "/schooldetails",
    name: "schooldetails",
    component: () => import("@/page/schooldetails.vue"),
    meta:{
      keepAlive: false,//此组件不需要被缓存
      isBack: false,
  }
  },
  // {
  //   path: "/introduce",
  //   name: "introduce",
  //   component: introduce
  // },
  // {
  //   path: "/collegenotice",
  //   name: "collegenotice",
  //   component: collegenotice,
  //   children: [
  //     {
  //       path: "collegetwo",
  //       name: "collegetwo",
  //       component: collegetwo
  //     },

  //   ]
  // },
  // {
  //   path: "/content/:id",
  //   name: "content",
  //   component: content
  // },
  // {
  //   path: "/zyjs",
  //   name: "zyjs",
  //   component: zyjs
  // },
];
const router = new VueRouter({
  mode: 'history',
  routes
});



router.beforeEach(beforeEach);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js